interface IPoint {
  img: string;
  alt: string;
  header: string;
  paragraph: string;
  reverse?: boolean;
  trimMobile?: boolean;
}

export const Point = ({
  img,
  alt,
  header,
  paragraph,
  reverse = false,
  trimMobile = false,
}: IPoint) => {
  return (
    <article
      className={`group surface-card grid items-center gap-[clamp(1.25rem,3vw,2rem)] overflow-hidden p-[clamp(1rem,2.5vw,1.35rem)] max-md:grid-cols-1 max-md:gap-0 max-md:p-0 ${
        reverse
          ? "grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)]"
          : "grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)]"
      }`}
    >
      <div
        className={`aspect-[4/3] overflow-hidden rounded-[var(--surface-card-radius-sm)] bg-white/[0.03] max-md:aspect-[16/10] max-md:rounded-[var(--surface-card-radius-sm)_var(--surface-card-radius-sm)_0_0] ${
          reverse ? "order-2 max-md:order-none" : ""
        }`}
      >
        <img
          alt={alt}
          src={img}
          width={800}
          height={600}
          loading="lazy"
          decoding="async"
          className={`block h-full w-full object-cover transition-transform duration-[350ms] ease-[ease] group-hover:scale-[1.03] ${
            trimMobile ? "max-md:scale-[1.12] max-md:group-hover:scale-[1.15]" : ""
          }`}
        />
      </div>
      <div
        className={`max-md:px-5 max-md:pt-5 max-md:pb-5 ${
          reverse ? "order-1 max-md:order-none" : ""
        }`}
      >
        <h3 className="mb-[0.65rem] font-shentox text-[clamp(1.05rem,2vw,1.3rem)] font-bold leading-[1.25] tracking-[0.06em] text-[#e8e8ef] uppercase">
          {header}
        </h3>
        <p
          className="m-0 font-jetbrains text-[0.92rem] text-[#a8a8bc]"
          style={{ lineHeight: 1.65 }}
        >
          {paragraph}
        </p>
      </div>
    </article>
  );
};
